import { FunctionComponent } from 'react'
import { useArchiveBidderRule, useBidderRules } from '~/api/bidder-rules.api'
import { useScopePermissions } from '~/auth/useScopePermissions'
import { useBidderRuleApiProduct } from '~/modules/monetization/inventory/bidder-rules/useBidderRuleCapabilities'
import { BIDDER_RULES_PATH } from '~/modules/monetization/inventory/bidder-rules/bidderRulesPath'
import { ArchivedRulesPage } from './ArchivedRulesPage'

/** The archived bidder rules. The page itself is shared with the other three kinds. */
export const ArchivedBidderRulesPage: FunctionComponent = () => {
  const apiProduct = useBidderRuleApiProduct()
  const { canArchive } = useScopePermissions()
  const { data: bidderRules, isLoading } = useBidderRules(apiProduct, false, true, true)
  const { mutateAsync: archiveBidderRule, isPending } = useArchiveBidderRule(apiProduct, {
    successToast: 'Bidder rule unarchived',
    errorToast: 'Could not unarchive this bidder rule',
  })

  return (
    <ArchivedRulesPage
      rules={bidderRules}
      isLoading={isLoading}
      noun={'bidder rule'}
      backLabel={'Back to bidder rules'}
      backPath={BIDDER_RULES_PATH}
      onUnarchive={(rule) => archiveBidderRule({ id: rule.id, archived: false })}
      isUnarchiving={isPending}
      canUnarchive={canArchive}
      backTrackingLabel={'common-bidder-rules-archived-back-navigate'}
      unarchiveTrackingLabel={'common-bidder-rules-unarchive'}
    />
  )
}
